import React, { useState } from "react";
import { FiAlignRight } from "react-icons/fi";
import { MdClose } from "react-icons/md";
import { logo } from "../../assets/index";
import { Link } from "react-scroll";
import { navLinksdata } from "../../constants";
import { IoMdSunny } from "react-icons/io";
import { BsMoonStarsFill } from "react-icons/bs";
import { ThemeContext } from "../../common/ThemeContext";

const Navbar = () => {
  const { theme, setTheme } = React.useContext(ThemeContext);

  const [sidebarright, setsidebarright] = useState("-344px");

  return (
    <section className="relative">
      <div className="w-full h-24 fixed top-0 left-0 z-40 bg-white dark:bg-bodyColor flex justify-between items-center font-titleFont border-b-[1px] dark:border-b-gray-600 px-4">
        <div className="flex items-center">
          <h1 className="text-2xl sm:text-4xl text-blue-600 dark:text-designColor font-semibold">
            {"< "}
          </h1>
          <h1 className="text-2xl sm:text-4xl text-black dark:text-gray-400 font-bold ml-2">
            {"KASHIF"}
          </h1>
          <h1 className="text-2xl sm:text-4xl text-blue-600 dark:text-designColor font-semibold ml-2">
            {"/ >"}
          </h1>
        </div>
        <div
          style={{ right: sidebarright, transition: "0.5s" }}
          className={`w-[325px] h-screen  fixed top-0 bg-blue-50 dark:bg-gray-900 p-4 z-50`}
        >
          <div className="flex flex-col gap-8 py-2 relative">
            <div>
              <img
                className="w-32 rounded-full bg-white dark:bg-gray-800"
                src={logo}
                alt="logo"
              />
              <h1 className="my-4 text-xl font-semibold text-blue-600 dark:text-designColor">
                M KASHIF BILAL
              </h1>
              <p className="text-sm dark:text-gray-400 text-black">
                If you're looking for a skilled and motivated web developer, I
                would love to connect with you!
              </p>
            </div>
            <ul className="flex flex-col gap-4">
              {navLinksdata.map((item) => (
                <li
                  onClick={() => {
                    setsidebarright("0px");
                  }}
                  key={item._id}
                  className="text-lg font-semibold dark:text-gray-600 text-gray-400 tracking-wide cursor-pointer hover:text-blue-600 dark:hover:text-designColor duration-300"
                >
                  <Link
                    to={item.link}
                    spy={true}
                    smooth={true}
                    offset={-70}
                    duration={500}
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
            <span
              onClick={() => {
                setsidebarright("-345px");
              }}
              className="absolute top-4 right-1 dark:text-designColor text-blue-600 duration-300 text-4xl cursor-pointer"
            >
              <MdClose />
            </span>
          </div>
        </div>
        <div className="flex items-center">


          <ul className="hidden lgl:inline-flex items-center gap-6 lg:gap-10">
            {navLinksdata.map(({ _id, title, link }) => (
              <li
                className="text-lg font-semibold dark:text-gray-600 text-gray-400 tracking-wide cursor-pointer hover:text-blue-600 dark:hover:text-designColor duration-300"
                key={_id}
              >
                <Link
                  activeClass="active"
                  to={link}
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={500}
                >
                  {title}
                </Link>
              </li>
            ))}
          </ul>
          <button className="mx-5" type="button">
            {theme === "dark" ? (
              <IoMdSunny
                onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
                className="text-gray-500 dark:text-gray-400 text-2xl cursor-pointer"
              />
            ) : (
              <BsMoonStarsFill
                onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
                className="text-gray-500 dark:text-gray-400 text-2xl cursor-pointer"
              />
            )}
          </button>
          <span
            onClick={() => {
              setsidebarright("0px");
            }}
            className="text-4xl lgl:hidden inline-flex items-center justify-center text-blue-600 dark:text-designColor cursor-pointer mt-2"
          >
            <FiAlignRight />
          </span>
        </div>
      </div>
    </section>
  );
};

export default Navbar;
